app.controller('BrowseEditSolutionCabinetOptionsController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    let solutionOptionTerms = $scope.solution_option_terms;
    solutionOptionTerms = solutionOptionTerms ? solutionOptionTerms : [];

    $scope.option_term_model_list = [];
    const optionTermModels = {};
    $scope.option_term_ids = {}

    $scope.cabinet_option_view_params = {};

    const originalOptionTermIDs = {}
    const defaultOptionTermIDs = {}

    $scope.can_reset = false;
    $scope.options_did_change = false;

    let relevantCart = [];
    let irrelevantCart = [];
    let unaffectedCart = [];
    const affectedCart = [];
    let unrelatedCart = [];

    $scope.have_relevant_cart = false;
    $scope.affected_cart_tally = 0;

    $scope.show_edit_response = false;

    $scope.edit_cart_response = null;


    for (let i = 0; i < solutionOptionTerms.length; i++) {
        const optionTermModel = solutionOptionTerms[i].option_term_model;
        if (optionTermModel.choiceList().length < 2) {
            continue;
        }
        $scope.option_term_model_list.push(optionTermModel);
        optionTermModels[optionTermModel.id] = optionTermModel
    }

    function prepareEditCabinetOptions() {

        resetEditResponse();

        $scope.option_term_ids = {}
        $scope.cabinet_option_view_params = {};
        let hettichNoteFound = false;
        let hettichCtaFound = false;
        for (let i = 0; i < solutionOptionTerms.length; i++) {
            const solutionOptionTerm = solutionOptionTerms[i];
            const optionID = solutionOptionTerm.option_id;
            const currentOptionTermID = solutionOptionTerm.currentOptionTermID;
            if (currentOptionTermID) {
                $scope.option_term_ids[optionID] = currentOptionTermID;
                originalOptionTermIDs[optionID] = currentOptionTermID;
            }
            const defaultOptionTermID = solutionOptionTerm.defaultOptionTermID;
            if (defaultOptionTermID) {
                defaultOptionTermIDs[optionID] = defaultOptionTermID;
            }
            let optionTitle;
            switch (optionID) {
                case "clicbox_colour":
                    optionTitle = "Cabinet Colour"
                    break
                case "hinge_colour":
                    optionTitle = "Hettich Hinge Colour"
                    break
                case "drawer_colour":
                    optionTitle = "Hettich Drawer Colour"
                    break
                default:
                    optionTitle = solutionOptionTerm.option_term_model.name + ":";
                    break

            }
            let noteID = null;
            if (["hinge_colour"].includes(optionID)) {
                if (!hettichNoteFound) {
                    noteID = "hettich";
                    hettichNoteFound = true;
                }
            } else if (optionID === "drawer_colour") {
                noteID = "drawer_colour";
            }
            let showHettichCTA = false;
            if (["hinge_colour", "drawer_colour"].includes(optionID)) {
                if (!hettichCtaFound) {
                    showHettichCTA = true;
                    hettichCtaFound = true;
                }
            }
            $scope.cabinet_option_view_params[optionID] = {
                option_title: optionTitle,
                note_id: noteID,
                show_hettich_cta: showHettichCTA
            }
        }

        determineSolutionCart();
        updateOptionsDidChange();
        updateCanReset();
        updateAffectedSolutionCart();

        setTimeout(() => {
            $scope.$apply();
        }, 1)
    }

    $scope.selectOptionTermChoice = function (optionID, optionTermID) {

        resetEditResponse();

        if ($scope.option_term_ids[optionID] === optionTermID) {
            optionTermID = "NONE";
        }
        $scope.option_term_ids[optionID] = optionTermID;

        updateOptionsDidChange();
        updateCanReset();
        updateAffectedSolutionCart();
    }


    function updateOptionsDidChange() {
        $scope.options_did_change = false;
        for (let optionID in $scope.option_term_ids) {
            if ($scope.option_term_ids[optionID] !== originalOptionTermIDs[optionID]) {
                $scope.options_did_change = true;
                return;
            }
        }
        for (let optionID in originalOptionTermIDs) {
            if (originalOptionTermIDs[optionID] !== $scope.option_term_ids[optionID]) {
                $scope.options_did_change = true;
                return;
            }
        }
    }

    function updateCanReset() {
        $scope.can_reset = false
        for (let optionID in $scope.option_term_ids) {
            if ($scope.option_term_ids[optionID] !== defaultOptionTermIDs[optionID]) {
                $scope.can_reset = true;
                return;
            }
        }
        for (let optionID in defaultOptionTermIDs) {
            if (defaultOptionTermIDs[optionID] !== $scope.option_term_ids[optionID]) {
                $scope.can_reset = true;
                return;
            }
        }
    }

    function determineSolutionCart() {

        relevantCart = $scope.complete_only_cart ? $scope.complete_only_cart.slice() : [];
        irrelevantCart = $scope.non_complete_cart ? $scope.non_complete_cart.slice() : [];
        unrelatedCart = $scope.unrelated_cart ? $scope.unrelated_cart.slice() : [];

        $scope.have_relevant_cart = !!relevantCart.length;
    }

    function updateAffectedSolutionCart() {
        affectedCart.length = 0;
        unaffectedCart = irrelevantCart.slice()
        $scope.affected_cart_tally = 0;
        for (let i = 0; i < relevantCart.length; i++) {
            const cartLine = relevantCart[i];
            let affected = false;
            for (let optionID in $scope.option_term_ids) {
                let toApplyValue = $scope.option_term_ids[optionID];
                toApplyValue = toApplyValue && toApplyValue !== "NONE" ? toApplyValue : null;
                let currentValue = null;
                let ignoreTerm = false;
                switch (optionID) {
                    case "clicbox_colour":
                        currentValue = cartLine.carcass_colour;
                        break
                    case "hinge_colour":
                        if (cartLine.requires_hinge_colour) {
                            currentValue = cartLine.hinge_colour;
                        } else {
                            ignoreTerm = true
                        }
                        break
                    case "drawer_colour":
                        if (cartLine.requires_hettich_colour) {
                            currentValue = cartLine.hettich_colour;
                        } else {
                            ignoreTerm = true
                        }
                        break
                    default:
                        ignoreTerm = true;
                        break;
                }
                if (ignoreTerm) {
                    continue;
                }
                currentValue = currentValue ? currentValue : null;
                if (toApplyValue !== currentValue) {
                    affected = true;
                    break;
                }
            }
            if (affected) {
                affectedCart.push(cartLine);
                const quantity = cartLine.quantity ? cartLine.quantity : 0;
                $scope.affected_cart_tally += quantity;
            } else {
                unaffectedCart.push(cartLine);
            }
        }
    }


    $scope.resetEdit = function () {
        for (let optionID in $scope.option_term_ids) {
            delete $scope.option_term_ids[optionID];
        }
        for (let optionID in defaultOptionTermIDs) {
            $scope.option_term_ids[optionID] = defaultOptionTermIDs[optionID];
        }

        updateOptionsDidChange();
        updateCanReset();
    }

    $scope.closeEdit = function () {
        resetEditResponse();
        if ($scope.showSolutionOverviewView) {
            $scope.showSolutionOverviewView(null);
        }
    }

    $scope.saveAndClose = function () {
        if ($scope.saveSolutionCabinetOptionTerms) {

            for (let i = 0; i < solutionOptionTerms.length; i++) {
                const solutionOptionTerm = solutionOptionTerms[i];
                const optionTermID = $scope.option_term_ids[solutionOptionTerm.option_id];
                solutionOptionTerm.currentOptionTermID = optionTermID ? optionTermID : null;
            }
            $scope.saveSolutionCabinetOptionTerms();
        }
        $rootScope.$broadcast("default_solution_cabinet_options_changed");
        $scope.closeEdit();
    }

    $scope.applyToCart = function () {

        resetEditResponse();

        const originalLines = [];
        const replacementLines = [];
        for (let i = 0; i < affectedCart.length; i++) {
            const cartLine = affectedCart[i];
            originalLines.push(cartLine);
            const replacementLine = JSON.parse(JSON.stringify(cartLine));
            for (let optionID in $scope.option_term_ids) {
                let toApplyValue = $scope.option_term_ids[optionID];
                toApplyValue = toApplyValue && toApplyValue !== "NONE" ? toApplyValue : null;
                switch (optionID) {
                    case "clicbox_colour":
                        replacementLine.carcass_colour = toApplyValue;
                        break
                    case "hinge_colour":
                        if (replacementLine.requires_hinge_colour) {
                            replacementLine.hinge_colour = toApplyValue;
                        }
                        break
                    case "drawer_colour":
                        if (replacementLine.requires_hettich_colour) {
                            replacementLine.hettich_colour = toApplyValue;
                        }
                        break
                    default:
                        break;
                }
            }
            replacementLines.push(replacementLine);
        }

        $scope.show_edit_response = true;

        $rootScope.service.order_edit.validateReplaceCart(originalLines, replacementLines, unaffectedCart, null, $scope.edit_cart_response);

    }

    $scope.dismissEditResponse = function () {
        resetEditResponse();
    }

    $scope.confirmEditResponse = function () {
        $rootScope.service.order_edit.applyReplacementCart($scope.edit_cart_response.replacement_cart, unrelatedCart, $scope.edit_cart_response, function (success) {
            if (success) {
                $scope.saveAndClose();
            }
        });
    }

    function resetEditResponse() {

        $scope.show_edit_response = false;

        $scope.edit_cart_response = new $rootScope.service.order_edit.EditCartResponseModel();

    }

    if ($scope.overview_solution_listeners) {
        $scope.overview_solution_listeners.prepareEditCabinetOptions = prepareEditCabinetOptions;
    }

}]);